var _toConsumableArray = require("/home/br/src/my/fp-tetris-game/node_modules/@babel/runtime/helpers/toConsumableArray");

var _ = require("lodash");

var fp = require("lodash/fp");

var p = require("fp-panel"); // Configuration


var GLOBAL = {
  color: "grey",
  count: 0,
  pause: false
}; // Panel functions

var getAry = function getAry(len, fnOrObject) {
  return _.range(len).map(function () {
    return _.isFunction(fnOrObject) ? fnOrObject() : _.cloneDeep(fnOrObject);
  });
};

var getEmptyRow = function getEmptyRow(columns) {
  return getAry(columns, p.createItem(GLOBAL.color));
};

var createPanel = function () {
  var savedRows = 0;
  var savedColumns = 0;
  return function (rows, columns) {
    savedRows = rows ? rows : savedRows;
    savedColumns = columns ? columns : savedColumns;
    return p.createPanel(savedRows, savedColumns);
  };
}();

var getEmptyRows = function getEmptyRows(count, columns) {
  return getAry(count, getEmptyRow(columns));
};

var isPaused = function isPaused() {
  return GLOBAL.pause === true;
};

var isSomeItemRow = fp.some(p.isBlankItem); // Remove row on panel

var addEmptyRow = function addEmptyRow(panel, rows) {
  var newPanel = _.cloneDeep(panel);

  var columns = newPanel[0].length;
  var count = rows - newPanel.length;
  GLOBAL.count += count;
  newPanel.unshift.apply(newPanel, _toConsumableArray(getEmptyRows(count, columns)));
  _.last(_.last(newPanel)).count = GLOBAL.count;
  return newPanel;
};

var removeFullRow = function removeFullRow(panel) {
  var rows = panel.length;

  var newPanel = _.filter(_.cloneDeep(panel), function (row) {
    return isSomeItemRow(row);
  });

  return addEmptyRow(newPanel, rows);
}; // Paint on panel


var paintO = function paintO(panel) {
  return p.paint(panel, [{
    row: 0,
    column: 0,
    zeroPoint: true
  }, {
    row: 0,
    column: 1,
    zeroPoint: true
  }, {
    row: 1,
    column: 0,
    zeroPoint: true
  }, {
    row: 1,
    column: 1,
    zeroPoint: true
  }], "yellow");
};

var paintI = function paintI(panel) {
  return p.paint(panel, [{
    row: 0,
    column: 0
  }, {
    row: 0,
    column: 1,
    zeroPoint: true
  }, {
    row: 0,
    column: 2
  }, {
    row: 0,
    column: 3
  }], "lime");
};

var paintT = function paintT(panel) {
  return p.paint(panel, [{
    row: 0,
    column: 1
  }, {
    row: 1,
    column: 0
  }, {
    row: 1,
    column: 1,
    zeroPoint: true
  }, {
    row: 1,
    column: 2
  }], "pink");
};

var paintJ = function paintJ(panel) {
  return p.paint(panel, [{
    row: 0,
    column: 2
  }, {
    row: 1,
    column: 0
  }, {
    row: 1,
    column: 1,
    zeroPoint: true
  }, {
    row: 1,
    column: 2
  }], "orange");
};

var paintL = function paintL(panel) {
  return p.paint(panel, [{
    row: 0,
    column: 0
  }, {
    row: 1,
    column: 0
  }, {
    row: 1,
    column: 1,
    zeroPoint: true
  }, {
    row: 1,
    column: 2
  }], "blue");
};

var paintS = function paintS(panel) {
  return p.paint(panel, [{
    row: 0,
    column: 1,
    zeroPoint: true
  }, {
    row: 0,
    column: 2
  }, {
    row: 1,
    column: 0
  }, {
    row: 1,
    column: 1
  }], "green");
};

var paintZ = function paintZ(panel) {
  return p.paint(panel, [{
    row: 0,
    column: 0
  }, {
    row: 0,
    column: 1,
    zeroPoint: true
  }, {
    row: 1,
    column: 1
  }, {
    row: 1,
    column: 2
  }], "red");
};

var panelList = [_.flow([createPanel, paintO, p.adjustToCenter]), _.flow([createPanel, paintI, p.adjustToCenter]), _.flow([createPanel, paintT, p.adjustToCenter]), _.flow([createPanel, paintJ, p.adjustToCenter]), _.flow([createPanel, paintL, p.adjustToCenter]), _.flow([createPanel, paintS, p.adjustToCenter]), _.flow([createPanel, paintZ, p.adjustToCenter])]; // Make tool panel

var createRandomToolPanel = function createRandomToolPanel(bgPanel) {
  var toolPanel = panelList[_.random(0, panelList.length - 1)]();

  var overlap = bgPanel ? p.isOverlap(bgPanel, toolPanel) : false;
  return overlap ? createPanel() : toolPanel;
}; // Process event


var getColorCount = function getColorCount(panel) {
  return _.reduce(_.flattenDepth(panel), function (sum, item) {
    return sum + (p.isItem(item) ? 1 : 0);
  }, 0);
};

var spaceKey = function spaceKey(_ref) {
  var bgPanel = _ref.bgPanel,
      toolPanel = _ref.toolPanel;
  GLOBAL.pause = !isPaused();
  return {
    bgPanel: bgPanel,
    toolPanel: toolPanel
  };
};

var leftKey = function leftKey(_ref2) {
  var bgPanel = _ref2.bgPanel,
      toolPanel = _ref2.toolPanel;
  var overlap = p.isOnTheLeftEdge(toolPanel) || p.isOverlap(bgPanel, p.left(toolPanel));
  return {
    bgPanel: bgPanel,
    toolPanel: overlap ? toolPanel : p.left(toolPanel)
  };
};

var upKey = function upKey(_ref3) {
  var bgPanel = _ref3.bgPanel,
      toolPanel = _ref3.toolPanel;
  var rotatedToolPanel = p.rotate(toolPanel);
  var overlap = getColorCount(toolPanel) !== getColorCount(rotatedToolPanel) || p.isOverlap(bgPanel, rotatedToolPanel);
  return {
    bgPanel: bgPanel,
    toolPanel: overlap ? toolPanel : rotatedToolPanel
  };
};

var rightKey = function rightKey(_ref4) {
  var bgPanel = _ref4.bgPanel,
      toolPanel = _ref4.toolPanel;
  var overlap = p.isOverlap(bgPanel, p.right(toolPanel)) || p.isOnTheRightEdge(toolPanel);
  return {
    bgPanel: bgPanel,
    toolPanel: overlap ? toolPanel : p.right(toolPanel)
  };
};

var downKey = function downKey(_ref5) {
  var bgPanel = _ref5.bgPanel,
      toolPanel = _ref5.toolPanel;
  var overlap = p.isOverlap(bgPanel, p.down(toolPanel)) || p.isOnTheBottomEdge(toolPanel);
  var newBgPanel = overlap ? p.add([bgPanel, toolPanel]) : bgPanel;
  var newToolPanel = overlap ? createRandomToolPanel(newBgPanel) : p.down(toolPanel);
  return {
    bgPanel: removeFullRow(newBgPanel),
    toolPanel: newToolPanel
  };
};

var rotateBgPanel = function rotateBgPanel(_ref6) {
  var bgPanel = _ref6.bgPanel,
      toolPanel = _ref6.toolPanel;
  return {
    bgPanel: p.rotate(bgPanel),
    toolPanel: toolPanel
  };
}; // Key definition


var withPauseKey = function withPauseKey(fn) {
  return function (panels) {
    return isPaused() ? panels : fn(panels);
  };
};

var scrollDownPanel = withPauseKey(downKey);
var keyFnList = [{
  key: "down",
  fn: scrollDownPanel
}, {
  key: "left",
  fn: withPauseKey(leftKey)
}, {
  key: "r",
  fn: rotateBgPanel
}, {
  key: "right",
  fn: withPauseKey(rightKey)
}, {
  key: "space",
  fn: spaceKey
}, {
  key: "up",
  fn: withPauseKey(upKey)
}];

var isValidKey = function isValidKey(key) {
  return _.some(keyFnList, function (item) {
    return _.isEqual(item.key, key);
  });
};

var init = function init() {
  var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    rows: 17,
    columns: 17
  },
      rows = _ref7.rows,
      columns = _ref7.columns,
      state = _ref7.state;

  return {
    bgPanel: state ? state.bgPanel : createPanel(rows, columns),
    toolPanel: state ? state.toolPanel : createRandomToolPanel()
  };
};

var tick = function tick(_ref8) {
  var bgPanel = _ref8.bgPanel,
      toolPanel = _ref8.toolPanel;
  return scrollDownPanel({
    bgPanel: bgPanel,
    toolPanel: toolPanel
  });
};

var key = function key(_key, state) {
  return isValidKey(_key) ? _.find(keyFnList, function (item) {
    return _.isEqual(item.key, _key);
  }).fn({
    bgPanel: state.bgPanel,
    toolPanel: state.toolPanel
  }) : {
    bgPanel: state.bgPanel,
    toolPanel: state.toolPanel
  };
};

var join = function join(state) {
  return p.add([state.bgPanel, state.toolPanel]);
};

var toArray = function toArray(_ref9) {
  var bgPanel = _ref9.bgPanel,
      toolPanel = _ref9.toolPanel;
  return [_.cloneDeep(bgPanel), _.cloneDeep(toolPanel)];
};

module.exports = {
  init: init,
  tick: tick,
  key: key,
  join: join,
  isBlank: p.isBlankItem,
  toArray: toArray
};